<template>
  <div class="cabeza">
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/images/Line-Magnetic-LOGO.png" alt="Line Magnetic" />
      </router-link>
    </div>
    <div class="menu">
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/produkty">Produkty</router-link></li>
        <li><a href="#pie">Kontakt</a></li>
        <li><router-link to="/partnerzy">Gdzie posłuchać</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
</script>
